import React from 'react';

const File = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="m6.75 4.25v23.5h18.5v-17h-7v-6.5h-0.75-10.75zm1.5 1.5h8.5v6.5h7v14h-15.5v-20.5z" />
    <path d="m18.283 4.3242-1.0176 1.1035 6.9863 6.4395 1.0176-1.1035-6.9863-6.4395z" />
  </svg>
);

export default File;
